import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

export const GlassCard = ({ 
  children, 
  className = '', 
  hover = true,
  delay = 0,
  ...props 
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-50px' }}
      transition={{ duration: 0.6, delay, ease: 'easeOut' }}
      whileHover={hover ? { 
        scale: 1.02,
        boxShadow: '0 0 20px rgba(79, 172, 254, 0.3)'
      } : {}}
      className={cn(
        'bg-white/5 backdrop-blur-md border border-white/10',
        'shadow-[0_4px_30px_rgba(0,0,0,0.1)] rounded-2xl',
        'p-6 sm:p-8 relative overflow-hidden',
        'transition-colors duration-300',
        hover && 'hover:bg-white/10 hover:border-white/20',
        className
      )}
      {...props}
    >
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#4facfe]/5 to-transparent pointer-events-none" />
      
      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
    </motion.div>
  );
};

export default GlassCard;
